import { createReducer } from '@reduxjs/toolkit'

import * as actions from '../../../../actions/DataPlatform/connections/SourceTables/actions'
import * as authenticationActions from '../../../../actions/Authentication/actions'

export type SourceTableReducerType = {
  // The raw preview payload per source table, typed by the reader.
  data: { [sourceTableId: string]: unknown }
  count: number
  fetching: boolean
  fetched: boolean
  error: boolean
  offset: number
  limit: number
}

const INITIAL_STATE: SourceTableReducerType = {
  data: {},
  count: 0,
  fetching: false,
  fetched: false,
  error: false,
  offset: 0,
  limit: 10
}

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getPreview, (state) => {
      state.fetching = true
      state.fetched = false
      state.error = false
    })
    .addCase(actions.getPreviewSuccess, (state, action) => {
      state.data[action.payload.data.data.id] = action.payload.data
      state.fetching = false
      state.fetched = true
      state.error = false
      state.limit = action.payload.limit
      state.offset = action.payload.offset
    })
    .addCase(actions.getPreviewFailed, (state) => {
      state.fetching = false
      state.fetched = false
      state.error = true
    })
    .addCase(actions.destroySuccess, (state, action) => {
      delete state.data[action.payload.deletedId]
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})
